import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { PortActionTypes, PortActionsUnion } from '@core/actions/port.actions';

import { Port } from '@app/models/port';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<Port> {
  loading: boolean;
  loaded: boolean;
  busy: boolean;
}

export const adapter: EntityAdapter<Port> = createEntityAdapter<Port>({
  selectId: (port: Port) => port.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  busy: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: PortActionsUnion
) {
  switch (action.type) {
    case PortActionTypes.Load:
    case PortActionTypes.Update:
    case PortActionTypes.Export:
    case PortActionTypes.Delete:
    case PortActionTypes.UploadProcessPending:
      return { ...state, loading: true, busy: true };

    case PortActionTypes.LoadFail:
    case PortActionTypes.ExportFail:
    case PortActionTypes.DeleteFail:
      return { ...state, loading: false, busy: false };

    case PortActionTypes.LoadSuccess:
    case PortActionTypes.ExportSuccess:
    case PortActionTypes.UploadProcessSuccess:
      return { ...state, loading: false, loaded: true, busy: false };

    case PortActionTypes.AddAll:
      return adapter.addAll(action.ports, state);

    case PortActionTypes.UpdateSuccess:
      return adapter.updateOne({ id: action.id, changes: action.data }, {
        ...state,
        loading: true,
        loaded: false,
        busy: false
      });

    case PortActionTypes.DeleteSuccess:
      return adapter.removeOne(action.id, {
        ...state,
        loading: true,
        loaded: false,
        busy: false
      });

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;

export const getState = createFeatureSelector<State>('ports');

export const getAll = createSelector(
  getState,
  selectAll
);

export const getBusy = createSelector(
  getState,
  (state: State) => state.busy
);